import { SEARCH_MODAL_TEST_IDS } from '@common/common-test-ids.const'

import type { SearchModalItem, SearchModalSection } from '../search-modal.interface'

import { SearchRow } from './SearchRow'

import styles from '../SearchModal.module.scss'

type SearchSectionProps = {
  query: string
  section: SearchModalSection
  selectedIndex: number
  startIndex: number
  onItemHover: (index: number) => void
  onItemSelect: (item: SearchModalItem) => void
}

export function SearchSection({
  query,
  section,
  selectedIndex,
  startIndex,
  onItemHover,
  onItemSelect,
}: SearchSectionProps) {
  return (
    <section className={styles.resultsSection} data-testid={SEARCH_MODAL_TEST_IDS.section}>
      {section.title.trim().length > 0 ? <h2 className={styles.sectionHeading}>{section.title}</h2> : null}
      <ul className={styles.itemsList} role="presentation">
        {section.items.map((item, itemIndex) => {
          const index = startIndex + itemIndex

          return (
            <SearchRow
              key={item.id}
              item={item}
              isSelected={index === selectedIndex}
              query={query}
              onHover={() => {
                onItemHover(index)
              }}
              onSelect={() => {
                onItemSelect(item)
              }}
            />
          )
        })}
      </ul>
    </section>
  )
}
